import styled from 'styled-components/macro'
import Icon from '../../../../commons/Icon'

export const InstallmentsOverview = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  background-color: ${({ theme }) => theme.colors.mono.greyLight};
  width: 20%;
  border-radius: 8px;
  padding: 2rem;
  margin-right: 1rem;

  @media ${({ theme }) => theme.screens.lg} {
    width: 100%;
    margin-bottom: 1.5rem;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 4rem;
    justify-content: space-between;
  }
`

export const InstallmentsOverviewTitle = styled.h3`
  @media ${({ theme }) => theme.screens.lg} {
    display: none;
  }
`

export const InstallmentsOverviewSubtitle = styled.p`
  color: ${({ theme }) => theme.colors.grey[600]}
`

export const InstallmentsOverviewValue = styled.span`
  font-weight: 700;
  color: ${({ theme }) => theme.colors.mono.blackDark};
`

export const InstallmentsTableWrapper = styled.div`
  flex: 1;
  min-height: 0;
  overflow: auto;

  .MuiDataGrid-root {
    min-width: 720px;
  }

  @media (min-width: 1200px) {
    .MuiDataGrid-root {
      width: 100%;  // desktop ocupa todo o espaço
    }
  }
`

export const LinkOutlined = styled.a`
  text-align: center;
  font-weight: 700;
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.primary.default};
  text-decoration: none;
  padding: 8px 16px;
  color: ${({ theme }) => theme.colors.primary.default};
  border: 1px solid ${({ theme }) => theme.colors.primary.default};
  border-radius: 4px;

  &:hover {
    color: ${({ theme }) => theme.colors.mono.white};
    background-color: ${({ theme }) => theme.colors.primary.default};
  }
`

export const SimpleIcon = styled(Icon)`
  width: 2rem;
  height: 2rem;
`

export const CopyBtn = styled.button`
  display: flex;
  align-items: center;
  font-size: 1.3rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary.default};
`

export const LoadingWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`